import React, { useState, useEffect } from "react";
import "./NewSeason.css";
import { Link } from "react-router-dom";
import { getCategories } from "../../../api/storefront";

const matchCategory = (list, key) => {
  if (!Array.isArray(list)) return 0;
  const slug = key.toLowerCase();
  const cat = list.find(
    (c) =>
      (c.slug && c.slug.toLowerCase().includes(slug)) ||
      (c.name && c.name.toLowerCase().includes(slug))
  );
  return cat ? Number(cat.product_count) || 0 : 0;
};

const NewSeason = (props) => {
  const p = props?.props || {};
  const [womenCount, setWomenCount] = useState(null);
  const [menCount, setMenCount] = useState(null);

  useEffect(() => {
    getCategories().then((list) => {
      setWomenCount(matchCategory(list, "women"));
      setMenCount(matchCategory(list, "men"));
    });
  }, []);

  const scrollToTop = () => window.scrollTo({ top: 0, behavior: "smooth" });
  const womenLabel =
    womenCount != null ? `${womenCount} Outfits to Rent` : "Outfits to Rent";
  const menLabel =
    menCount != null ? `${menCount} Outfits to Rent` : "Outfits to Rent";

  const womenBg = p.womenImageUrl ? { backgroundImage: `url(${p.womenImageUrl})`, backgroundSize: 'cover', backgroundPosition: 'center' } : undefined;
  const menBg = p.menImageUrl ? { backgroundImage: `url(${p.menImageUrl})`, backgroundSize: 'cover', backgroundPosition: 'center' } : undefined;
  const blockOrder = Array.isArray(p.blockOrder) && p.blockOrder.length === 2 ? p.blockOrder : ['women', 'men'];

  const blocks = {
    women: {
      className: 'newSeasonBlock newSeasonWomen',
      style: womenBg,
      verticalLabel: 'Women',
      title: p.womenTitle || "Women's Rentals",
      countLabel: womenLabel,
    },
    men: {
      className: 'newSeasonBlock newSeasonMen',
      style: menBg,
      verticalLabel: 'Men',
      title: p.menTitle || "Men's Spring Rentals 2026",
      countLabel: menLabel,
    },
  };

  return (
    <section className="newSeason">
      <h2 className="newSeasonTitle">{p.title || "New Season – Rent the Trends"}</h2>
      <div className="newSeasonGrid">
        {blockOrder.map((key) => {
          const b = blocks[key];
          if (!b) return null;
          return (
            <Link
              key={key}
              to="/shop"
              className={b.className}
              onClick={scrollToTop}
              style={b.style}
            >
              <span className="newSeasonVerticalLabel">{b.verticalLabel}</span>
              <div className="newSeasonOverlay">
                <h3>{b.title}</h3>
                <p>{b.countLabel}</p>
              </div>
            </Link>
          );
        })}
      </div>
    </section>
  );
};

export default NewSeason;
